import { useState, useContext } from "react";
import "./RecruitmentPartnersAndClients.css";
import RecruitmentPartners from "./RecruitmentPartnersKendo";
import Customer from "./CustomerKendo";
import Agency from "./AgencyKendo";
import { UserTypeContext } from "../../AppRoute";
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";

const RecruitmentPartnersAndClients = () => {
  const { userType } = useContext(UserTypeContext);
  const [tabName, setTabName] = useState("Recruitment Partner");
  const [openModal, setOpenModal] = useState(false);
  const history = useNavigate();

  const tabClicked = (tabValue) => {
    setTabName(tabValue);
  };
  const goToAdminDashboard = () => {
    history("/admin-home");
  }

  const getButtonName = () => {
    if (tabName === "Recruitment Partner") {
      return "Add Recruitment Organization";
    }
    else if (tabName === "Customer") {
      return "Add Customer";
    }
    else if (tabName === "Agencies") {
      return "Add Agency";
    }
  }

  return (
    <>
      {userType === "Admin" ? (<>
        <div className='mainContainer_recPartnersAndClients'>
          <div className="communityHeader_recPartnersAndClients">
            <div className="goBackButton" onClick={(e) => goToAdminDashboard()}>
              <Tooltip title="Go Back to Dashboard" placement="bottom">
                <ArrowBackIcon sx={{ fontSize: 20 }} />
              </Tooltip>
            </div>
            <div className="communityTitle">Recruitment Organizations, Customers & Agencies</div>
          </div>
          <div className="tab_header">
            <div className="tabButtonContainer">
              <div
                className={`tabButton ${tabName === "Recruitment Partner" ? "tabActive" : ""
                  }`}
                onClick={() => tabClicked("Recruitment Partner")}
              >
                Recruitment Organizations
              </div>
              <div
                className={`tabButton ${tabName === "Customer" ? "tabActive" : ""
                  }`}
                onClick={() => tabClicked("Customer")}
              >
                Customers
              </div>
              <div
                className={`tabButton ${tabName === "Agencies" ? "tabActive" : ""
                  }`}
                onClick={() => tabClicked("Agencies")}
              >
                Agencies
              </div>
            </div>

            <button
              onClick={(e) => setOpenModal(true)}
            >
              {getButtonName()}
            </button>
          </div>

          {tabName === "Recruitment Partner" ? (
            <RecruitmentPartners openModal={openModal} setOpenModal={setOpenModal} />
          ) : tabName === "Customer" ? (
            <Customer openModal={openModal} setOpenModal={setOpenModal} />
          ) : (
            <Agency openModal={openModal} setOpenModal={setOpenModal} />
          )}

        </div>


      </>) : (
        <UnauthorizedAccess />
      )}
    </>
  );
};

export default RecruitmentPartnersAndClients;
